module.exports = __webpack_public_path__ + "img/timestudy-banner.4dd0497a.png";